import { LeftOutlined } from '@ant-design/icons'
import { Button, ButtonProps } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useLocales } from 'src/locales'

type Props = {
  /** Where to go when the page was opened directly (no in-app history). */
  fallbackPath: string
} & Omit<ButtonProps, 'onClick' | 'icon'>

export const BackButton = ({ fallbackPath, ...props }: Props) => {
  const { t } = useLocales()
  const navigate = useNavigate()

  // react-router keeps the history index in history.state; 0 means this is the first in-app entry
  const onBack = () => {
    const historyIndex = (window.history.state as { idx?: number } | null)?.idx

    if (historyIndex) navigate(-1)
    else navigate(fallbackPath)
  }

  return (
    <Button
      icon={<LeftOutlined />}
      className="fit-content"
      onClick={onBack}
      {...props}
    >
      {t('common.back')}
    </Button>
  )
}
